module.exports = "/images/404_cloud.png?0f4bc32b0f52f7cfb7d19305a6517724";